import {useState} from 'react'
import {View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'

import {
  OnboardingControls,
  OnboardingDescriptionText,
  OnboardingPosition,
  OnboardingTitleText,
} from '#/screens/Onboarding/Layout'
import {useOnboardingInternalState} from '#/screens/Onboarding/state'
import {
  AUDIENCE_ICONS,
  AUDIENCE_TARGETS,
  MAX_AUDIENCE_TARGETS,
} from '#/screens/Onboarding/StepGoal/data'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import * as Toggle from '#/components/forms/Toggle'
import {Text} from '#/components/Typography'

export function StepAudience() {
  const {t: l} = useLingui()
  const t = useTheme()
  const {state, dispatch} = useOnboardingInternalState()

  const [audience, setAudience] = useState<string[]>(
    state.goalStepResults.audience,
  )

  function onChange(vals: string[]) {
    if (vals.length <= MAX_AUDIENCE_TARGETS) setAudience(vals)
  }

  function onContinue() {
    dispatch({type: 'setGoalResults', results: {audience}})
    dispatch({type: 'next'})
  }

  return (
    <View style={[a.align_start, a.gap_sm]} testID="onboardingAudience">
      <OnboardingPosition />
      <OnboardingTitleText>
        <Trans>Who's Your Audience? 🎯</Trans>
      </OnboardingTitleText>
      <OnboardingDescriptionText>
        <Trans>
          Select up to {MAX_AUDIENCE_TARGETS} categories that best represent who
          you create for.
        </Trans>
      </OnboardingDescriptionText>

      <View style={[a.w_full, a.pt_lg]}>
        <Toggle.Group
          values={audience}
          onChange={onChange}
          label={l`Select your target audiences`}>
          <View style={[a.flex_row, a.flex_wrap, a.gap_sm]}>
            {AUDIENCE_TARGETS.map(target => {
              const isDisabled =
                audience.length >= MAX_AUDIENCE_TARGETS &&
                !audience.includes(target)
              return (
                <Toggle.Item key={target} name={target} label={target}>
                  {({selected}) => (
                    <View
                      style={[
                        a.px_md,
                        a.py_sm,
                        a.rounded_full,
                        a.border,
                        selected
                          ? {
                              borderColor: 'transparent',
                              ...t.atoms.bg_contrast_975,
                            }
                          : t.atoms.border_contrast_low,
                        isDisabled && {opacity: 0.4},
                      ]}>
                      <Text
                        style={[
                          a.text_sm,
                          a.font_bold,
                          selected && t.atoms.text_inverted,
                        ]}
                        emoji>
                        {AUDIENCE_ICONS[target]} {target}
                      </Text>
                    </View>
                  )}
                </Toggle.Item>
              )
            })}
          </View>
        </Toggle.Group>
      </View>

      <OnboardingControls.Portal>
        <Button
          disabled={audience.length === 0}
          testID="onboardingContinue"
          color="primary"
          size="large"
          label={l`Continue to next step`}
          onPress={onContinue}>
          <ButtonText>
            <Trans>Continue</Trans>
          </ButtonText>
        </Button>
      </OnboardingControls.Portal>
    </View>
  )
}
